import React from "react";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/16/solid";

const HeaderContact = () => {
  const { data } = useQuery({
    queryKey: "getContact",
    queryFn: () =>
      axios.get(`${BASEURL}contacts`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <div className="grid grid-cols-2 gap-10">
      <div className="flex items-center">
        <EnvelopeIcon className="w-5 h-5 mr-2 text-deep-grey" />
        <p className="text-deep-grey text-md font-semibold hover:text-speed-red lg:block md:block sm:hidden max-sm:hidden">
          <a href={`mailto:${data?.email[0]}`}>{data?.email[0]}</a>
        </p>
      </div>
      <div className="flex items-center">
        <PhoneIcon className="w-5 h-5 mr-2 text-deep-grey" />
        <p
          className="text-deep-grey text-md font-semibold hover:text-speed-red lg
        :block md:block sm:hidden max-sm:hidden"
        >
          <a href={`tel:${data?.phone[0]}`}>{data?.phone[0]}</a>
        </p>
      </div>
    </div>
  );
};

export default HeaderContact;
